import React, { Fragment } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Input } from 'components/molecules/v2/input';
import { Password } from 'components/molecules/v2/password-field';
import InputWithLabel from 'components/molecules/input-with-label';
import UserIcon from 'icons/user-white.svg';
import { useAuthDispatch, useAuthState } from 'src/components/auth/hook';
import { validationSchema } from 'components/partners/login/validations';
import { PARTNER_LOGIN } from 'src/formMapper';

const LoginForm = () => {
  const { client } = useAuthState();
  const router = useRouter();
  const dispatch = useAuthDispatch();

  const {
    handleSubmit,
    register,
    watch,
    setError,
    formState: { isSubmitting, errors }
  } = useForm({
    shouldFocusError: false,
    resolver: yupResolver(validationSchema),
    mode: 'onChange'
  });

  const onFormSubmit = async (values) => {
    try {
      const response = await client.post('/partner/login/', values);
      const {
        data: { access, refresh }
      } = response;
      window.localStorage.setItem('access', access);
      window.localStorage.setItem('refresh', refresh);
      const account = await client.get('/account/');

      dispatch({
        type: 'set',
        payload: {
          user: account.data.data.user
        }
      });

      router.push('/partners/leads');
    } catch (error) {
      setError('password', {
        type: 'server',
        message: error.response.data.non_field_errors
      });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className='grid grid-cols-1 gap-4'>
          <InputWithLabel
            label={PARTNER_LOGIN.email.label}
            name='email'
            error={!!errors.email}
            errorMessage={errors?.email?.message}
            labelSize='large'
          >
            <Input
              name='email'
              type='email'
              placeholder={PARTNER_LOGIN.email.placeholder}
              error={!!errors.email}
              errorMessage={errors?.email?.message}
              register={register}
              value={watch('email')}
              data-testid='email'
            />
          </InputWithLabel>
          <InputWithLabel
            label={PARTNER_LOGIN.password.label}
            name='password'
            error={!!errors.password}
            errorMessage={errors?.password?.message}
            labelSize='large'
          >
            <Password
              name='password'
              type='password'
              error={!!errors.password}
              errorMessage={errors?.password?.message}
              register={register}
              value={watch('password')}
              data-testid='password'
            />
          </InputWithLabel>
        </div>
        <div className='flex flex-col lg:flex-row lg:justify-between mt-5 space-y-4 space-x-3'>
          <button
            type='submit'
            text='Login'
            disabled={isSubmitting}
            aria-disabled={isSubmitting}
            className='space-x-2 transition-transform ease-out transform app-btn app-btn-primary group hover:-translate-y-1'
            data-testid='submit'
          >
            <UserIcon />
            <span>{PARTNER_LOGIN.button.submit}</span>
          </button>
          <div className='app-text-dm-small text-gray text-opacity-80 mt-[-12px]'>
            Forgot Password?
            <Link href='/partners/forgot-password'>
              <a href='/partners/forgot-password'>
                <span className='uppercase app-text-link text-secondary'> reset here</span>
              </a>
            </Link>
          </div>
        </div>
      </form>
    </>
  );
};

LoginForm.propTypes = {};

export default LoginForm;
